import React from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";
import { Form } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";

export const commonRenderInput = ({ input, label, subLabel, need, placeholder, type, disabled, meta: { touched, error, warning } }) => {
  const needStar = need ? '*' : '';
  const classGroup = type === 'hidden' ? 'no-display' : 'form-group';
  const classShowLabel = label ? 'area-label' : 'no-display';

  return (
    <div className={classGroup}>
      <span className={ classShowLabel }><label>{label}</label><span className='need-star-label'>{ needStar }</span><span className='sub-label'>{ subLabel }</span></span>
      <input type={type} className="form-control" placeholder={placeholder} readOnly={disabled} {...input} />
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}

export const commonRenderSelect = ({ callback, input, label, subLabel, need, placeholder, type, disabled, options, meta: { touched, error, warning } }) => {
  const needStar = need ? '*' : '';
  const classGroup = type === 'hidden' ? 'no-display' : 'form-group';

  return (
    <div className={classGroup}>
      <input type='hidden' className="form-control" placeholder={placeholder} readOnly={true} {...input} />
      <Form.Group controlId="exampleForm.SelectCustomSizeLg">
        <span className='area-label'>
          <Form.Label>{label}</Form.Label><span className='need-star-label'>{ needStar }</span><span className='sub-label'>{ subLabel }</span>
        </span>        
        <Form.Control as="select" size="lg" custom="true" onChange={callback} value={input.value} disabled={disabled}>
          { commonRenderSelectOptions(options) }
        </Form.Control>
      </Form.Group>
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}

const commonRenderSelectOptions = (options) => {
  if (options) {
      return options
      .map((option, index) => {
          return (
            <option key={index} value={option.value || option}>{option.key || option}</option>
          )
      });
  }
}

export const commonRenderCheckbox = ({ callback, input, label, subLabel, need, disabled, meta: { touched, error, warning } }) => {
  const needStar = need ? '*' : '';
  let classIcon = input.value ? 'icon-btn-checkbox-p' : 'icon-btn-checkbox-n';
  let classAreaBtnCheck = disabled ? 'area-btn-check disabled' : 'area-btn-check';

  return (
    <div className='form-group'>
      <span className='area-label'><label>{label}</label><span className='need-star-label'>{ needStar }</span><span className='sub-label'>{ subLabel }</span></span>
      <input type='hidden' className="form-control" readOnly={disabled} {...input} />
      <div className={classAreaBtnCheck} onClick={callback}>
        <span className={classIcon} />
      </div>
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}

export const commonRenderDatepicker = ({ callback, input, label, subLabel, need, type, disabled, meta: { touched, error, warning } }) => {
  const needStar = need ? '*' : '';
  let inputContent, classAreaDatePicker, datePickerContent;
  let date = input.value ? moment(input.value, "YYYY/MM/DD").toDate() : new Date();
  if (disabled) {
    inputContent = (
      <input type='text' className="form-control" readOnly={true} {...input} />
    );
    datePickerContent = (
      <span className="no-datepicker"/>
    )
    classAreaDatePicker = 'area-datepick no-display';
  } else {
    inputContent = (
      <input type='hidden' className="form-control" readOnly={disabled} {...input} />
    );
    datePickerContent = (
      <DatePicker
        selected={date}
        onChange={(date) => {
          if (date) {
            const strDate = moment(date).format('YYYY/MM/DD');
            callback(strDate);
          }            
        }}
        dateFormat="yyyy/MM/dd"
      />
    );
    classAreaDatePicker = 'area-datepick';
  }

  const classGroup = type === 'hidden' ? 'no-display' : 'form-group';
  return (
    <div className={classGroup}>
      <span className='area-label'><label>{label}</label><span className='need-star-label'>{ needStar }</span><span className='sub-label'>{ subLabel }</span></span>
      { inputContent }
      <div className={ classAreaDatePicker }>
        { datePickerContent }
      </div>      
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}

export const commonRenderInlineInput = ({ input, label, placeholder, type, disabled, meta: { touched, error, warning } }) => {
  const classGroup = type === 'hidden' ? 'no-display' : 'form-group row inline-form-group';

  return (
    <div className={classGroup}>
        <div className='col-sm-6 area-form-label'><label>{label}</label></div>
        <div className='col-sm-6'><input type={type} className="form-control" placeholder={placeholder} readOnly={disabled} {...input} /></div>        
        <div className='import-notice-text col-sm-12'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}

export const commonRenderTableInput = ({ input, label, placeholder, type, disabled, meta: { touched, error, warning } }) => {
  const classGroup = type === 'hidden' ? 'no-display' : 'form-list-row';
  return (
    <tr className={classGroup}>
      <td className='area-form-list-col-label'>{ label }</td>
      <td className='area-form-list-col-input'>
        <input type={type} className="form-control" placeholder={placeholder} readOnly={disabled} {...input} />
        <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
      </td>
    </tr>
  )
}